import axios from 'axios'
import {ParamsModel} from 'src/app/modules/common/Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL
export const NABIL_AUCTION_SUBSCRIBER_API = `${API_URL}/nabil-auction-subscribers`

export const service = {
  getNabilAuctionSubscriber: (params: ParamsModel) => {
    return axios.get(NABIL_AUCTION_SUBSCRIBER_API, {params})
  },
  deleteNabilAuctionSubscriber: (data: {ids: string[]}) => {
    return axios.delete(`${NABIL_AUCTION_SUBSCRIBER_API}/bulk-delete`, {data})
  },
  enableNabilAuctionSubscriber: (data: Array<string>) => {
    return axios.patch(`${NABIL_AUCTION_SUBSCRIBER_API}/enable`, {ids: data})
  },
  disableNabilAuctionSubscriber: (data: Array<string>) => {
    return axios.patch(`${NABIL_AUCTION_SUBSCRIBER_API}/disable`, {ids: data})
  },
  singleEnableNabilAuctionSubscriber: (data: string) => {
    return axios.patch(`${NABIL_AUCTION_SUBSCRIBER_API}/enable`, {ids: [data]})
  },
  singleDisableNabilAuctionSubscriber: (data: string) => {
    return axios.patch(`${NABIL_AUCTION_SUBSCRIBER_API}/disable`, {ids: [data]})
  },
}
